<div class="hint-box">
  <div class="hint">{{ i18n.get('searchAddressUsageHint') }}</div>
</div>
<mat-form-field appearance="outline" subscriptSizing="dynamic" [class.linkedText]="showLinkedText()">
  <mat-label>{{ label() }}</mat-label>
  @if (showLinkedText()) {
    <app-contenteditable
      #linkedTextContent
      class="linkedTextContent"
      [formControl]="messageContentControl()"
      (quillKeydown)="onKeyDownFormatedText($event)"
      (quillContentChanged)="onInputFormatedText()"
      (quillClick)="handleTextContentClick($event)"
      (quillDblclick)="handleTextContentDblClick($event)"
    ></app-contenteditable>
  } @else {
    <textarea
      #textContent
      class="textContent"
      matInput
      [formControl]="messageContentControl()"
      (keydown)="onKeyDownText($event)"
      (input)="onInputText()"
      (dblclick)="onDoubleClickText($event)"
      rows="10"
      [readonly]="addressSelection()"
    ></textarea>
  }
</mat-form-field>
<div class="actions">
  <button mat-stroked-button type="button" tabindex="-1" (click)="openAddressSearch()">
    <mat-icon>add</mat-icon>
    {{ i18n.get('addAddress') }}
  </button>
  <button mat-stroked-button type="button" tabindex="-1" (click)="markPotentialAddresses()">
    <mat-icon>search</mat-icon>
    {{ i18n.get('markPotentialAddresses') }}
  </button>
  <button mat-stroked-button type="button" tabindex="-1" (click)="unmarkPotentialAddresses()">
    <mat-icon>restore</mat-icon>
    {{ i18n.get('unmarkPotentialAddresses') }}
  </button>
</div>
<div
  class="addresSearch"
  [class.linkedText]="showLinkedText()"
  [class.empty]="!addressSearchTerm()"
  [style.display]="
    addressSelection() ?
      showLinkedText() ? 'block'
      : 'flex'
    : 'none'
  "
  [ngStyle]="showLinkedText() ? { 'left.px': addressSelectionPosition.x, 'top.px': addressSelectionPosition.y } : null"
>
  <div class="title">{{ i18n.get('searchAddress') }}</div>
  <input
    #addresSearchField
    matInput
    class="mat-mdc-form-field"
    [matAutocomplete]="autocomplete.autocompleteRef"
    [ngModelOptions]="{ standalone: true }"
    [ngModel]="addressSearchTerm()"
    [placeholder]="i18n.get('searchAddressTypeToSearch')"
    (ngModelChange)="addressSearchTerm.set($event)"
    (keydown)="onKeydownAddressSearch($event)"
  />
  @if (!addressSearchTerm()) {
    <div class="search-hint">
      <span class="search-hint-esc">{{ i18n.get('searchAddressEscToExit') }}</span>
    </div>
  }
  <app-search-autocomplete
    #autocomplete
    [searchTerm]="addressSearchTerm()"
    [foundLocations]="foundLocations()"
    (active)="previewCoordinate($event)"
    (selected)="useResult($event)"
  ></app-search-autocomplete>
</div>
